const ButtonLinkWrapper = ({href, onClick, style, children, target}) => {
    return <a href={href} onClick={onClick} style={style} target={target}>
        {children}
    </a>
}

export default ButtonLinkWrapper